import React, { useState } from 'react';
import FormSkeleton from './FormSkeleton';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Loader2 } from 'lucide-react';
import { Form } from './ui/form';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Checkbox } from './ui/checkbox';

function CustomerForm({
  brandPromotionalMessage,
  handleNameChange,
  handlePhoneChange,
  handleEmailChange,
  nameError,
  phoneNumberError,
  emailError,
  name,
  email,
  phoneNumber,
  businessName,
  handleSubmit,
  apiError,
  apiErrorMessage,
  errorColor,
  loading,
  isIncludingPhone,
  isIncludingEmail,
}) {
  const [isTwilioOptIn, setIsTwilioOptIn] = useState(false);

  const handleClick = (link) => {
    window.open(link, '_blank');
  };

  return (
    <div className='flex flex-col lg:w-[800px] sm:w-8/12 w-full px-10'>
      {businessName === '' ? (
        <div>
          <FormSkeleton
            apiError={apiError}
            apiErrorMessage={
              apiErrorMessage
                ? apiErrorMessage
                : 'Server error! Please try again in a few minutes.'
            }
            errorColor={errorColor}
          />
        </div>
      ) : (
        <Card className='p-10 shadow-lg'>
          <h1 className='text-center scroll-m-20 text-4xl font-extrabold tracking-tight md:text-5xl md:p-5 p-2'>
            {businessName}
          </h1>

          <p className='leading-tight py-2 text-sm md:text-base text-center'>
            {brandPromotionalMessage}
          </p>
          <Form>
            <form onSubmit={handleSubmit} className='space-y-2'>
              <div className='grid w-full gap-2'>
                <Label htmlFor='name'>Name</Label>
                <Input
                  className={`${
                    nameError ? 'border-destructive' : 'border-brand'
                  }`}
                  type='name'
                  id='name'
                  onChange={handleNameChange}
                  placeholder='John Doe'
                  error={nameError}
                  value={name}
                />
                <p className='text-xs text-destructive'>
                  {nameError ? 'Name is required' : ''}
                </p>
              </div>

              {isIncludingPhone ? (
                <div className='grid w-full gap-2'>
                  <Label htmlFor='phone'>Phone Number</Label>
                  <Input
                    className={`${
                      phoneNumberError ? 'border-destructive' : 'border-brand'
                    }`}
                    type='phone'
                    id='phone'
                    onChange={handlePhoneChange}
                    placeholder='204 123 1234'
                    value={phoneNumber}
                  />
                  <p className='text-xs text-destructive'>
                    {phoneNumberError ? 'Invalid phone number' : ''}
                  </p>
                </div>
              ) : null}

              {isIncludingEmail ? (
                <div className='grid w-full gap-2'>
                  <Label htmlFor='email'>Email Address</Label>
                  <Input
                    className={`${
                      emailError ? 'border-destructive' : 'border-brand'
                    }`}
                    type='email'
                    id='email'
                    onChange={handleEmailChange}
                    value={email}
                    placeholder='example@email.com'
                  />
                  <p className='text-xs text-destructive'>
                    {emailError ? 'Invalid email' : ''}
                  </p>
                </div>
              ) : null}
              <div className='items-top flex space-x-2'>
                <Checkbox
                  id='terms'
                  onCheckedChange={() => setIsTwilioOptIn(!isTwilioOptIn)}
                />
                <div className='grid gap-1.5 leading-none'>
                  <label
                    htmlFor='terms'
                    className='text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
                  >
                    Accept terms and conditions
                  </label>
                  <p className='text-xs md:text-sm text-muted-foreground'>
                    By submitting this form, you consent to receive marketing
                    text messages from {businessName} and comply with our&nbsp;
                    <Button
                      onClick={() =>
                        handleClick('https://www.chekkit.io/text-policy')
                      }
                      variant='link'
                      className='text-inherit text-xs md:text-sm p-0 h-auto'
                    >
                      policy
                    </Button>
                    . Standard message and data rates may apply. Message
                    frequency varies. Text STOP to opt out.
                  </p>
                </div>
              </div>
              <Button
                className='w-full mt-4 bg-brand'
                type='submit'
                loading={loading}
                disabled={!isTwilioOptIn}
              >
                {loading && <Loader2 className='mr-2 h-4 w-4 animate-spin' />}
                Submit
              </Button>

              <div className='flex flex-row justify-center'>
                <Button
                  onClick={() =>
                    handleClick('https://www.chekkit.io/privacy-policy')
                  }
                  variant='link'
                >
                  Privacy Policy
                </Button>
                <Button
                  onClick={() =>
                    handleClick('https://www.chekkit.io/terms-of-use')
                  }
                  variant='link'
                >
                  Terms of Service
                </Button>
              </div>
            </form>
          </Form>
        </Card>
      )}
    </div>
  );
}

export default CustomerForm;
